import { useMemo } from "react";
import { getSessionStorage } from "../helpers/session_storage";

const useAuth = () => {
  const sessionStorageUser = getSessionStorage("user");
  const user = sessionStorageUser ? sessionStorageUser : null;
  console.log(user);

  return useMemo(() => ({ user, role: user?.role }), [user]);
};

export default useAuth;
